/**
 * Parses a cURL command string and extracts its components.
 * @param {string} curlString The cURL command.
 * @returns {object} A structured object representing the request.
 */
export const parseCurl = (curlString) => {
  const request = {
    method: "GET",
    url: "",
    headers: [],
    body: null,
  };

  // Match URL
  const urlMatch = curlString.match(/['"]?((?:https?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=]*)['"]?/);
  if (urlMatch && urlMatch[1]) {
    let url = urlMatch[1];
    if (!url.startsWith("http")) {
      url = `https://` + url;
    }
    request.url = url;
  }

  // Match method
  const methodMatch = curlString.match(/-X\s+(\w+)/);
  if (methodMatch && methodMatch[1]) {
    request.method = methodMatch[1].toUpperCase();
  }

  // Match headers
  const headerMatches = [...curlString.matchAll(/-H\s+['"]([^'"]+)['"]/g)];
  request.headers = headerMatches.map((match) => {
    const [key, ...valueParts] = match[1].split(/:\s*/);
    const value = valueParts.join(":");
    return { key, value: value || "" };
  });

  // Match body
  const bodyMatch = curlString.match(/-d\s+(?:'([^']*)'|"([^"]*)"|([^'"\s]\S*))/s);
  const rawBody = bodyMatch ? (bodyMatch[1] || bodyMatch[2] || bodyMatch[3]) : null;

  if (rawBody) {
    let sanitizedBody = rawBody;
    try {
      // Parse and re-stringify to sanitize the JSON content
      const jsonBody = JSON.parse(rawBody);
      sanitizedBody = JSON.stringify(jsonBody, null, 2);
    } catch (e) {
      // If it's not valid JSON, just normalize line endings
      sanitizedBody = rawBody.replace(/\r\n/g, '\n');
      console.warn("Could not parse cURL body as JSON. Treating as raw text.", e);
    }

    request.body = {
      mode: "raw",
      raw: sanitizedBody,
      options: {
        raw: {
          language: "json",
        },
      },
    };
  }

  return request;
};